var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H10V5C10 6.65685 11.3431 8 13 8H16V18C16 19.1046 15.1046 20 14 20H4C2.89543 20 2 19.1046 2 18V4ZM12 5V2.41421L15.5858 6H13C12.4477 6 12 5.55228 12 5ZM4 0C1.79086 0 0 1.79086 0 4V18C0 20.2091 1.79086 22 4 22H14C16.2091 22 18 20.2091 18 18V6.41421C18 5.88378 17.7893 5.37507 17.4142 5L13 0.585786C12.6249 0.210713 12.1162 0 11.5858 0H4ZM5 9C4.44772 9 4 9.44771 4 10C4 10.5523 4.44772 11 5 11H7C7.55228 11 8 10.5523 8 10C8 9.44771 7.55228 9 7 9H5ZM5 13C4.44772 13 4 13.4477 4 14C4 14.5523 4.44772 15 5 15H10C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13H5Z",
    fill: "#006B6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPdf);
export default __webpack_public_path__ + "static/media/ic-pdf.22d4d97fb25ce0ee1b5baab5b59564b2.svg";
export { ForwardRef as ReactComponent };